module.exports = __webpack_public_path__ + "img/agpz-bus-disabled.08a8d098.svg";